import { defineMessages } from 'react-intl';
import * as PrintActions from '../store/printing/print.actions';

/**
 * @typedef {import('../prop-types/intl').MessageDescriptorPropType} MessageDescriptor
 */

export const messages = defineMessages({
  packingSlip: {
    description: 'printDocumentButtonContainers.packingSlip',
    defaultMessage: 'Packing Slip',
    id: '3Zjc3d',
  },
  packingSlipPrintToModalHeader: {
    description: 'print to modal header for Packing Slip',
    defaultMessage: 'Packing Slip Printing',
    id: 'HUDMDK',
  },
  label: {
    description: 'printDocumentButtonContainers.label',
    defaultMessage: 'Label',
    id: 'NYpfdJ',
  },
  labelPrintToModalHeader: {
    description: 'print to modal header for Label',
    defaultMessage: 'Label Printing',
    id: 'gGbT3h',
  },
  returnLabel: {
    description: 'print document return label',
    defaultMessage: 'Return Label',
    id: 'hsUomg',
  },
  pickList: {
    description: 'printDocumentButtonContainers.pickList',
    defaultMessage: 'Pick List',
    id: 'T+dLOa',
  },
  pickListPrintToModalHeader: {
    description: 'print to modal header for Pick List',
    defaultMessage: 'Pick List Printing',
    id: '1Isp4R',
  },
  customsForm: {
    description: 'printDocumentButtonContainers.customsForm',
    defaultMessage: 'Customs Form',
    id: '04Xjlo',
  },
  customsFormPrintToModalHeader: {
    description: 'print to modal header for Customs Form',
    defaultMessage: 'Customs Form Printing',
    id: '93KS5A',
  },
  orderSummary: {
    description: 'printDocumentButtonContainers.orderSummary',
    defaultMessage: 'Order Summary',
    id: 'QDxyEK',
  },
  orderSummaryPrintToModalHeader: {
    description: 'print to modal header for Order Summary',
    defaultMessage: 'Order Summary Printing',
    id: 'ibZpig',
  },
  endOfDayForm: {
    description: 'printDocumentButtonContainers.endOfDayForm',
    defaultMessage: 'End Of Day Form',
    id: 'hNkKQ1',
  },
  endOfDayFormPrintToModalHeader: {
    description: 'print to modal header for End Of Day Form',
    defaultMessage: 'End Of Day Form Printing',
    id: 'wPmZoW',
  },
  hotkeysAndBarcode: {
    description: 'printDocumentButtonContainers.hotkeysAndBarcode',
    defaultMessage: 'Hotkeys And Barcode',
    id: 'YRqyLO',
  },
  shipmentManifest: {
    description: 'printDocumentButtonContainers.shipmentManifest',
    defaultMessage: 'Shipment Manifest',
    id: 'Z1rKxJ',
  },
  printShipmentManifest: {
    description: 'print shipment manifest from the read-only rate card in order details',
    defaultMessage: 'Print Shipment Manifest',
    id: 'ZJxynK',
  },
  shipmentManifestPrintToModalHeader: {
    description: 'print to modal header for Shipment Manifest',
    defaultMessage: 'Shipment Manifest Printing',
    id: 'C4T7GD',
  },
  otherForms: {
    description: 'printDocumentButtonContainers.otherForms',
    defaultMessage: 'Other Forms',
    id: 'KQ8jNq',
  },
  otherFormsPrintToModalHeader: {
    description: 'print to modal header for Other Forms',
    defaultMessage: 'Other Forms Printing',
    id: 'Wof8hn',
  },
  warehouseLabels: {
    description: 'name of the warehouse labels document type',
    defaultMessage: 'Warehouse Labels',
    id: 'RD+qYC',
  },
  warehouseLabelsPrintToModalHeader: {
    description: 'print warehouse labels from the read-only rate card in order details',
    defaultMessage: 'Warehouse Labels Printing',
    id: 'thIvRm',
  },
  purchaseOrder: {
    description: 'Print document purchase order button',
    defaultMessage: 'Purchase Order',
    id: '4cXA4E',
  },
  purchaseOrderPrintToModalHeader: {
    description: 'Print to modal header for Purchase Order',
    defaultMessage: 'Purchase Order Printing',
    id: 'HjaxkV',
  },
  locationBarcode: {
    description: 'Print location barcode button',
    defaultMessage: 'Location Barcode',
    id: 'eQT8L0',
  },
  locationBarcodePrintToModalHeader: {
    description: 'Print to modal header for location barcode',
    defaultMessage: 'Location Barcode Printing',
    id: 'qgaSA+',
  },
  uomBarcode: {
    description: 'Print UoM barcode button',
    defaultMessage: 'UoM Barcode',
    id: 'Ad5/vm',
  },
  uomBarcodePrintToModalHeader: {
    description: 'Print to modal header for UoM barcodes',
    defaultMessage: 'UoM Barcode Printing',
    id: 'jiDrWL',
  },
  freightBillOfLading: {
    description: 'printDocumentButtonContainers.freightBillOfLading',
    defaultMessage: 'Bill of Lading',
    id: 'u2CsPh',
  },
  freightBillOfLadingPrintToModalHeader: {
    description: 'print to modal header for Bill of Lading',
    defaultMessage: 'Print Bill of Lading To',
    id: 'GCRmRW',
  },
  freightPackingList: {
    description: 'printDocumentButtonContainers.freightPackingList',
    defaultMessage: 'Packing List',
    id: '1vcIpl',
  },
  freightPackingListPrintToModalHeader: {
    description: 'print to modal header for Freight Packing List',
    defaultMessage: 'Print Packing List To',
    id: 'ymhIjR',
  },
  freightPalletLabel: {
    description: 'printDocumentButtonContainers.freightPalletLabel',
    defaultMessage: 'Pallet Label',
    id: 'MJkhBR',
  },
  freightPalletLabelPrintToModalHeader: {
    description: 'print to modal header for Pallet Label',
    defaultMessage: 'Print Pallet Label To',
    id: 'hd24mJ',
  },
  freightProofOfDelivery: {
    description: 'printDocumentButtonContainers.freightProofOfDelivery',
    defaultMessage: 'Proof of Delivery',
    id: '5MdVfm',
  },
  freightProofOfDeliveryPrintToModalHeader: {
    description: 'print to modal header for Proof of Delivery',
    defaultMessage: 'Print Proof of Delivery To',
    id: 'WtM5an',
  },
  freightWeightAndInspection: {
    description: 'printDocumentButtonContainers.freightWeightAndInspection',
    defaultMessage: 'Weight and Inspection',
    id: 'FNsEc0',
  },
  freightWeightAndInspectionPrintToModalHeader: {
    description: 'print to modal header for Weight and Inspection',
    defaultMessage: 'Print Weight and Inspection To',
    id: 'KMHouA',
  },
  freightAccessorialsReceipt: {
    description: 'printDocumentButtonContainers.freightAccessorialsReceipt',
    defaultMessage: 'Accessorials Receipt',
    id: 'DiyDVM',
  },
  freightAccessorialsReceiptPrintToModalHeader: {
    description: 'print to modal header for Accessorials Receipt',
    defaultMessage: 'Print Accessorials Receipt To',
    id: 'WcYtgL',
  },
  freightOther: {
    description: 'printDocumentButtonContainers.freightOther',
    defaultMessage: 'Other',
    id: 'O4nUXE',
  },
  freightOtherPrintToModalHeader: {
    description: 'print to modal header for Other Freight Document',
    defaultMessage: 'Print Other Freight Document To',
    id: '+K9f4N',
  },
});

export const LABEL = 'label';
export const BATCH_LABELS = 'batch-labels';
export const PACKING_SLIP = 'packing-slip';
export const BATCH_PACKING_SLIP = 'batch-packing-slip';
export const RETURN_LABEL = 'return-label';
export const PICK_LIST = 'pick-list';
export const BATCH_PICK_LIST = 'batch-pick-list';
export const CUSTOMS_FORMS = 'customs-forms';
export const BATCH_CUSTOMS_FORMS = 'batch-customs-forms';
export const OTHER_FORMS = 'other-forms';
export const ORDER_SUMMARY = 'order-summary';
export const EOD_FORM = 'end-of-day-form';
export const HOTKEYS_AND_BARCODE = 'hotkeys-and-barcode';
export const SHIPMENT_MANIFEST = 'shipment-manifest';
export const BATCH_SHIPMENT_MANIFEST = 'batch-shipment-manifest';
export const WAREHOUSE_LABELS = 'warehouse-labels';
export const PURCHASE_ORDER = 'purchase-order';
export const LOCATION_BARCODE = 'location-barcode';
export const UOM_BARCODE = 'uom-barcode';
export const FREIGHT_BILL_OF_LADING = 'freight-bill-of-lading';
export const FREIGHT_PACKING_LIST = 'freight-packing-list';
export const FREIGHT_PALLET_LABEL = 'freight-pallet-label';
export const FREIGHT_PROOF_OF_DELIVERY = 'freight-proof-of-delivery';
export const FREIGHT_WEIGHT_AND_INSPECTION = 'freight-weight-and-inspection';
export const FREIGHT_ACCESSORIALS_RECEIPT = 'freight-accessorials-receipt';
export const FREIGHT_OTHER = 'freight-other';

/**
 * @typedef {object} DocumentTypeEnum
 * @property {string} identifier
 * @property {string} apiDownloadPath
 * @property {string} printSettingKey
 * @property {string} v2printSettingKey
 * @property {string} templateIdQueryParameterName
 * @property {MessageDescriptor} documentNameTranslation
 * @property {MessageDescriptor} documentNameTranslationForPrintSettingsModal
 * @property {(ids: string) => object|null} getMarkPrintedAction
 */

/**
 * @type {{[key: string]: DocumentTypeEnum}}
 */
export const DocumentType = Object.freeze({
  PackingSlip: {
    identifier: PACKING_SLIP,
    apiDownloadPath: '/api/download/packingslip',
    printSettingKey: PACKING_SLIP,
    v2printSettingKey: 'ps',
    templateIdQueryParameterName: 'packingSlipTemplateId',
    documentNameTranslation: messages.packingSlip,
    documentNameTranslationForPrintSettingsModal: messages.packingSlipPrintToModalHeader,
    getMarkPrintedAction: (fulfillmentPlanIds) => PrintActions.markPackingSlipPrinted(fulfillmentPlanIds, true),
  },
  Label: {
    identifier: LABEL,
    apiDownloadPath: '/api/download/label',
    printSettingKey: LABEL,
    v2printSettingKey: LABEL,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.label,
    documentNameTranslationForPrintSettingsModal: messages.labelPrintToModalHeader,
    getMarkPrintedAction: (fulfillmentIds) => PrintActions.markLabelPrinted([], fulfillmentIds, true),
  },
  ReturnLabel: {
    identifier: RETURN_LABEL,
    apiDownloadPath: '/api/download/label',
    printSettingKey: LABEL,
    v2printSettingKey: LABEL,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.returnLabel,
    documentNameTranslationForPrintSettingsModal: messages.labelPrintToModalHeader,
    getMarkPrintedAction: (fulfillmentIds) => PrintActions.markLabelPrinted([], fulfillmentIds, true),
  },
  PickList: {
    identifier: PICK_LIST,
    apiDownloadPath: '/api/download/picklist',
    printSettingKey: PICK_LIST,
    v2printSettingKey: 2,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.pickList,
    documentNameTranslationForPrintSettingsModal: messages.pickListPrintToModalHeader,
    getMarkPrintedAction: (fulfillmentPlanIds) => PrintActions.markPickListPrinted(fulfillmentPlanIds, true),
  },
  BatchPickList: {
    identifier: BATCH_PICK_LIST,
    apiDownloadPath: '/api/download/picklist/fulfillmentPlanSets',
    printSettingKey: PICK_LIST,
    v2printSettingKey: 2,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.pickList,
    documentNameTranslationForPrintSettingsModal: messages.pickListPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  CustomsForm: {
    identifier: CUSTOMS_FORMS,
    apiDownloadPath: '/api/download/form',
    printSettingKey: CUSTOMS_FORMS,
    v2printSettingKey: CUSTOMS_FORMS,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.customsForm,
    documentNameTranslationForPrintSettingsModal: messages.customsFormPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  OtherForms: {
    identifier: OTHER_FORMS,
    apiDownloadPath: '/api/download/form',
    printSettingKey: 'other',
    v2printSettingKey: 'other',
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.otherForms,
    documentNameTranslationForPrintSettingsModal: messages.otherFormsPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  BatchCustomsForm: {
    identifier: BATCH_CUSTOMS_FORMS,
    apiDownloadPath: '/api/download/form/fulfillmentPlanSet/',
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.customsForm,
    documentNameTranslationForPrintSettingsModal: messages.customsFormPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  BatchOtherForms: {
    apiDownloadPath: 'download/form/hasForms/fulfillmentPlanSet/',
  },
  BatchPackingSlip: {
    identifier: BATCH_PACKING_SLIP,
    apiDownloadPath: '/api/download/packingslip/fulfillmentPlanSets',
    printSettingKey: PACKING_SLIP,
    v2printSettingKey: 'ps',
    templateIdQueryParameterName: 'packingSlipTemplateId',
    documentNameTranslation: messages.packingSlip,
    documentNameTranslationForPrintSettingsModal: messages.packingSlipPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  BatchLabel: {
    identifier: BATCH_LABELS,
    apiDownloadPath: '/api/download/label/fulfillmentPlanSets',
    printSettingKey: LABEL,
    v2printSettingKey: LABEL,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.label,
    documentNameTranslationForPrintSettingsModal: messages.labelPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  OrderSummary: {
    identifier: ORDER_SUMMARY,
    apiDownloadPath: '/api/download/report/orderSummary',
    printSettingKey: ORDER_SUMMARY,
    v2printSettingKey: 1,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.orderSummary,
    documentNameTranslationForPrintSettingsModal: messages.orderSummaryPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  EndOfDayForm: {
    identifier: EOD_FORM,
    apiDownloadPath: '/api/download/EODForm',
    printSettingKey: EOD_FORM,
    v2printSettingKey: 'eod',
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.endOfDayForm,
    documentNameTranslationForPrintSettingsModal: messages.endOfDayFormPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  HotkeysAndBarcode: {
    identifier: HOTKEYS_AND_BARCODE,
    apiDownloadPath: '/api/download/barcodes',
    documentNameTranslation: messages.hotkeysAndBarcode,
    getMarkPrintedAction: () => null,
  },
  ShipmentManifest: {
    identifier: SHIPMENT_MANIFEST,
    apiDownloadPath: '/api/download/manifest',
    printSettingKey: SHIPMENT_MANIFEST,
    v2printSettingKey: 5,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.shipmentManifest,
    documentNameTranslationForPrintSettingsModal: messages.shipmentManifestPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  BatchShipmentManifest: {
    identifier: BATCH_SHIPMENT_MANIFEST,
    apiDownloadPath: '/api/download/manifest/fulfillmentPlanSet',
    printSettingKey: SHIPMENT_MANIFEST,
    v2printSettingKey: 5,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.shipmentManifest,
    documentNameTranslationForPrintSettingsModal: messages.shipmentManifestPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  WarehouseLabels: {
    identifier: WAREHOUSE_LABELS,
    apiDownloadPath: '/api/download/asn',
    printSettingKey: WAREHOUSE_LABELS,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.warehouseLabels,
    documentNameTranslationForPrintSettingsModal: messages.warehouseLabelsPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  PurchaseOrder: {
    identifier: PURCHASE_ORDER,
    apiDownloadPath: 'api/purchaseOrders/print',
    printSettingKey: PURCHASE_ORDER,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.purchaseOrder,
    documentNameTranslationForPrintSettingsModal: messages.purchaseOrderPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  LocationBarcode: {
    identifier: LOCATION_BARCODE,
    apiDownloadPath: 'api/locationBarcode/print',
    printSettingKey: LOCATION_BARCODE,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.locationBarcode,
    documentNameTranslationForPrintSettingsModal: messages.locationBarcodePrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  UomBarcode: {
    identifier: UOM_BARCODE,
    apiDownloadPath: 'api/uomBarcode/print',
    printSettingKey: UOM_BARCODE,
    v2printSettingKey: UOM_BARCODE,
    templateIdQueryParameterName: 'templateId',
    documentNameTranslation: messages.uomBarcode,
    documentNameTranslationForPrintSettingsModal: messages.uomBarcodePrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  FreightBillOfLading: {
    identifier: FREIGHT_BILL_OF_LADING,
    printSettingKey: FREIGHT_BILL_OF_LADING,
    documentNameTranslation: messages.freightBillOfLading,
    documentNameTranslationForPrintSettingsModal: messages.freightBillOfLadingPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  FreightPackingList: {
    identifier: FREIGHT_PACKING_LIST,
    printSettingKey: FREIGHT_PACKING_LIST,
    documentNameTranslation: messages.freightPackingList,
    documentNameTranslationForPrintSettingsModal: messages.freightPackingListPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  FreightPalletLabel: {
    identifier: FREIGHT_PALLET_LABEL,
    printSettingKey: FREIGHT_PALLET_LABEL,
    documentNameTranslation: messages.freightPalletLabel,
    documentNameTranslationForPrintSettingsModal: messages.freightPalletLabelPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  FreightProofOfDelivery: {
    identifier: FREIGHT_PROOF_OF_DELIVERY,
    printSettingKey: FREIGHT_PROOF_OF_DELIVERY,
    documentNameTranslation: messages.freightProofOfDelivery,
    documentNameTranslationForPrintSettingsModal: messages.freightProofOfDeliveryPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  FreightWeightAndInspection: {
    identifier: FREIGHT_WEIGHT_AND_INSPECTION,
    printSettingKey: FREIGHT_WEIGHT_AND_INSPECTION,
    documentNameTranslation: messages.freightWeightAndInspection,
    documentNameTranslationForPrintSettingsModal: messages.freightWeightAndInspectionPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  FreightAccessorialsReceipt: {
    identifier: FREIGHT_ACCESSORIALS_RECEIPT,
    printSettingKey: FREIGHT_ACCESSORIALS_RECEIPT,
    documentNameTranslation: messages.freightAccessorialsReceipt,
    documentNameTranslationForPrintSettingsModal: messages.freightAccessorialsReceiptPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
  FreightOther: {
    identifier: FREIGHT_OTHER,
    printSettingKey: FREIGHT_OTHER,
    documentNameTranslation: messages.freightOther,
    documentNameTranslationForPrintSettingsModal: messages.freightOtherPrintToModalHeader,
    getMarkPrintedAction: () => null,
  },
});
